import React from 'react';

import { Stack, Link, Typography, LegacyTextList } from '@gogame/components';

const Parent = ({ onClick, row }) => {
  if (row.partnerAudience) {
    return (
      <Stack zeroMinWidth={true} height={'100%'} justifyContent={'center'}>
        <Link onClick={(e) => onClick(e, { id: row.partnerAudience.id })}>
          <Typography
            lineClamp={2}
            sx={{ whiteSpace: 'normal' }}
            variant={'body2'}
          >
            {row.partnerAudience.name}
          </Typography>
        </Link>
      </Stack>
    );
  }

  const campaigns = row.campaigns || [];
  const adSets = row.adSets || [];
  const count = campaigns.length + adSets.length;

  return (
    <Stack zeroMinWidth={true} height={'100%'} justifyContent={'center'}>
      <LegacyTextList limit={1} count={count} unitsName={'Entities'}>
        {campaigns.length ? (
          <Typography variant={'body2'}>Campaigns:</Typography>
        ) : null}
        {campaigns.map((row, i) => (
          <LegacyTextList.Item key={i} ellipsis={true}>
            {row.name}
          </LegacyTextList.Item>
        ))}

        {adSets.length ? (
          <Typography variant={'body2'}>AdSets:</Typography>
        ) : null}
        {adSets.map((row, i) => (
          <LegacyTextList.Item key={i} ellipsis={true} variant={'body2'}>
            {row.name}
          </LegacyTextList.Item>
        ))}
      </LegacyTextList>
    </Stack>
  );
};

export default Parent;
